import React, { FunctionComponent } from 'react';
import DoughnutMetricCard from '../../DoughnutMetricCards/DoughnutMetricCard';
import { IDoughnutMetricCardsProps } from '../../DoughnutMetricCards/types';

const MeetingTeamDoughnutMetricCards: FunctionComponent<IDoughnutMetricCardsProps> = ({ report }) => {
  return (
    <div className="panel my-1 p-2">
      <div className="aic flex theme-gradient-2 mb-2 panel px-2 py-1">
        <h2 className="white bold">Metrics</h2>
      </div>
      <div className="border-radius-1 lightGray-bg p-2 container">
        <DoughnutMetricCard
          title="Attendance"
          description="How many sessions were held"
          totalLabel="Total Available Sessions"
          total={report.attendance.totalSessions}
          incompleteLabel="Not Held"
          segments={[
            {
              label: 'Sessions Held',
              value: report.attendance.sessionsHeld,
              color: 'green',
            },
          ]}
        />
        <DoughnutMetricCard
          title="To Do's"
          description="How many action items were completed by the team"
          totalLabel="Total To Do's"
          total={report.actionItems.total}
          segments={[
            {
              label: 'Completed On Time',
              value: report.actionItems.completedOnTime,
              color: 'green',
            },
            {
              label: 'Completed Overdue',
              value: report.actionItems.completedOverdue,
              color: 'orange',
            },
          ]}
        />
        <DoughnutMetricCard
          title="Expired Goals"
          description="How many goals were completed by the team"
          totalLabel="Total Goals"
          total={report.goals.totalExpiredGoals}
          segments={[
            {
              label: 'Completed On Time',
              value: report.goals.completedOnTime,
              color: 'green',
            },
            {
              label: 'Completed Overdue',
              value: report.goals.completedOverdue,
              color: 'orange',
            },
          ]}
        />
        <DoughnutMetricCard
          title="Current Goals"
          description="How many goals are on or off track"
          totalLabel="Total Goals"
          total={report.goals.totalCurrentGoals}
          showIncomplete={false}
          segments={[
            {
              label: 'On Track',
              value: report.goals.onTrackGoals,
              color: 'green',
            },
            {
              label: 'Off Track',
              value: report.goals.offTrackGoals,
              color: 'orange',
            },
          ]}
        />
      </div>
    </div>
  );
};
export default MeetingTeamDoughnutMetricCards;
